import axios from 'axios';

const api = axios.create({ baseURL: '/api' });

// Attach JWT token to every request
api.interceptors.request.use(config => {
  const token = localStorage.getItem('par_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Redirect to login on 401
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('par_token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// ── Auth ────────────────────────────────────────────────────
export const login = (email, password) =>
  api.post('/auth/login', { email, password });

export const register = (data) =>
  api.post('/auth/register', data);

export const getMe = () =>
  api.get('/auth/me');

export const forgotPassword = (email) =>
  api.post('/auth/forgot-password', { email });

export const resetPassword = (token, password) =>
  api.post('/auth/reset-password', { token, password });

// ── Agent ───────────────────────────────────────────────────
export const updateProfile = (data) =>
  api.put('/agent/profile', data);

export const uploadLogo = (file) => {
  const form = new FormData();
  form.append('logo', file);
  return api.post('/agent/upload-logo', form);
};

export const uploadHeadshot = (file) => {
  const form = new FormData();
  form.append('headshot', file);
  return api.post('/agent/upload-headshot', form);
};

export const getReports = () =>
  api.get('/agent/reports');

export const getCreditHistory = () =>
  api.get('/agent/credit-history');

// ── Reports ─────────────────────────────────────────────────
export const generateReport = (formData) =>
  api.post('/reports/generate', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });

export const getReport = (id) =>
  api.get(`/reports/${id}`);

// ── Credits ─────────────────────────────────────────────────
export const getCreditPacks = () =>
  api.get('/credits/packs');

export const createCheckout = (pack_id) =>
  api.post('/credits/checkout', { pack_id });

export default api;
